/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ParserDependencies } from './dependenciesParserClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createParser } from '../../factoriesAny.js';
export var parserDependencies = {
  ParserDependencies: ParserDependencies,
  typedDependencies: typedDependencies,
  createParser: createParser
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesParser.generated.js
// module id = 1472
// module chunks = 0